import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@config/firebase';

/**
 * Hook para comprobar si la app está en modo mantenimiento
 */
export const useMaintenanceMode = () => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const settingsDoc = await getDoc(doc(db, 'settings', 'app'));
        if (settingsDoc.exists()) {
          setMaintenanceMode(settingsDoc.data().maintenanceMode === true);
        }
      } catch (e) {
        // Si falla, asumir que NO está en mantenimiento (permitir acceso)
      }
      setChecked(true);
    };
    check();
  }, []);

  return { maintenanceMode, checked };
};
